<template>
	<div class="earlyTime">
		<div class="themName">发表时间:</div>
		<span class="themlis hovertext" :class="[selDays === '' ?selected: '']" @click="seletedF('')">全部</span>
		<span class="themlis hovertext" :class="[selDays === '1' ?selected: '']" @click="seletedF('1')">今天</span>
		<span class="themlis hovertext" :class="[selDays === '24' ?selected: '']" @click="seletedF('24')">24小时</span>
		<span class="themlis hovertext" :class="[selDays === '2' ?selected: '']" @click="seletedF('2')">2天</span>
		<span class="themlis hovertext" :class="[selDays === '3' ?selected: '']" @click="seletedF('3')">3天</span>
		<span class="themlis hovertext" :class="[selDays === '7' ?selected: '']" @click="seletedF('7')">7天</span>
		<span class="themlis hovertext" :class="[selDays === '0' ?selected: '']" @click="seletedF('0')">自定义</span>
		<div v-show="selDays === '0'" class="timePart">
			<!-- <el-date-picker v-model="update_time" type="datetime" placeholder="选择日期" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss">
			</el-date-picker> -->
			<el-date-picker  v-model="value1" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
			 size="mini" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" @change="timeChange" prefix-icon="iconfont iconrili" :default-time="['00:00:00','23:59:59']">
			</el-date-picker>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				selected:{
					selectedClass:true,
					textColor:true,
					borderColor:true
				},
				isSelected: '7',
				value1:'',
			}
		},
        props: {
            selDays: {
                type: String | Number
            }
        },
		methods: {
			seletedF(val) {
				this.isSelected = val
				this.$emit('changeTime',{'type':val,'val':null})
			},
			timeChange(val) {

				this.$emit('changeTime',{'type':this.isSelected,'val':val})
			}
		}
	}
</script>

<style lang="less">
	.earlyTime {
		font-size: 14px;
		display: flex;
		align-items: center;
        flex-wrap: wrap;
		.themlis {
			margin: 0px 5px;
			display: inline-block;
			padding: 0px 5px;
			height: 24px;
			line-height: 22px;
			border: 1px solid transparent;
			border-radius: 5px;
            cursor: pointer;

			&.selectedClass {
				//color: #41a0ff;
				border: 1px solid #41a0ff;
				border-radius: 5px;
			}
		}

		.themName {
			color: @huiseColor;
			height: 40px;
			line-height: 40px;
		}

		.el-date-editor--daterange.el-input__inner {
			//width: 386px;
		}
		.el-date-editor--datetimerange.el-input__inner{
			//width: 396px;
			width: 348px;
		}
		position: relative;
		.timePart{
			z-index: 1000;
			position: absolute;
			background-color: #fff;
			// top:-40px;
			// left:54px;
			top:-1px;
			left:434px;
		}
	}
</style>
